import * as R from 'remeda';
import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { useApiClient } from '../../../../lib/apiClient';

const COMMENTS_USERS_QUERY_KEY = 'comments-users';

export const useCommentsUsers = (userIds: number[]) => {
  const api = useApiClient();

  return useQuery({
    queryKey: [COMMENTS_USERS_QUERY_KEY, userIds] as const,
    queryFn: () =>
      api.request(
        endpoints.users.list({
          id: userIds,
          pageSize: userIds?.length ?? 1,
        })
      ),
    enabled: !!userIds && userIds.length > 0,
    select: response => R.mapToObj(response.results, user => [user.url, user]),
  });
};
